import React, { useState } from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
export const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = e => {
    e.preventDefault();
    // In a real implementation, you would send this data to a server
    console.log(formData);
    setIsSubmitted(true);
    setFormData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: ''
    });
  };
  return <div className="bg-white" data-id="element-240">
      <div className="relative bg-rose-900 h-80" data-id="element-241">
        <div className="absolute inset-0 overflow-hidden" data-id="element-242">
          <img src="https://images.unsplash.com/photo-1577553696425-6a0654d2c122?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80" alt="UK Map" className="w-full h-full object-cover opacity-20" data-id="element-243" />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex flex-col justify-center" data-id="element-244">
          <h1 className="text-3xl font-extrabold text-white sm:text-4xl" data-id="element-245">
            Contact Us
          </h1>
          <p className="mt-4 text-xl text-rose-100 max-w-3xl" data-id="element-246">
            Get in touch with our team for appliance repairs, service plan
            inquiries, or any other questions.
          </p>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 -mt-16" data-id="element-247">
        <div className="bg-white rounded-lg shadow-xl overflow-hidden" data-id="element-248">
          <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-249">
            <div className="p-6 sm:p-8 lg:p-10 bg-gray-50" data-id="element-250">
              <h2 className="text-2xl font-bold text-rose-900 mb-6" data-id="element-251">
                Get in Touch
              </h2>
              {isSubmitted ? <div className="bg-green-50 border border-green-200 rounded-md p-4 mb-6" data-id="element-252">
                  <p className="text-green-800" data-id="element-253">
                    Thank you for your message! We'll get back to you as soon as
                    possible.
                  </p>
                </div> : null}
              <form onSubmit={handleSubmit} data-id="element-254">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-6" data-id="element-255">
                  <div data-id="element-256">
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-257">
                      Your Name *
                    </label>
                    <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} className="block w-full rounded-md border-gray-300 shadow-sm focus:border-rose-500 focus:ring-rose-500 sm:text-sm" required data-id="element-258" />
                  </div>
                  <div data-id="element-259">
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-260">
                      Email Address *
                    </label>
                    <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="block w-full rounded-md border-gray-300 shadow-sm focus:border-rose-500 focus:ring-rose-500 sm:text-sm" required data-id="element-261" />
                  </div>
                </div>
                <div className="mb-6" data-id="element-262">
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-263">
                    Phone Number
                  </label>
                  <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="block w-full rounded-md border-gray-300 shadow-sm focus:border-rose-500 focus:ring-rose-500 sm:text-sm" data-id="element-264" />
                </div>
                <div className="mb-6" data-id="element-265">
                  <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-266">
                    Subject *
                  </label>
                  <input type="text" id="subject" name="subject" value={formData.subject} onChange={handleChange} className="block w-full rounded-md border-gray-300 shadow-sm focus:border-rose-500 focus:ring-rose-500 sm:text-sm" required data-id="element-267" />
                </div>
                <div className="mb-6" data-id="element-268">
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-269">
                    Your Message *
                  </label>
                  <textarea id="message" name="message" rows={5} value={formData.message} onChange={handleChange} className="block w-full rounded-md border-gray-300 shadow-sm focus:border-rose-500 focus:ring-rose-500 sm:text-sm" required data-id="element-270"></textarea>
                </div>
                <div data-id="element-271">
                  <button type="submit" className="inline-flex justify-center items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-rose-900 hover:bg-rose-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rose-500 w-full" data-id="element-272">
                    Send Message
                  </button>
                </div>
              </form>
            </div>
            <div className="p-6 sm:p-8 lg:p-10 bg-rose-900 text-white" data-id="element-273">
              <h2 className="text-2xl font-bold mb-6" data-id="element-274">Contact Information</h2>
              <div className="space-y-6" data-id="element-275">
                <div className="flex items-start" data-id="element-276">
                  <MapPin className="h-6 w-6 text-amber-400 mr-3 mt-0.5" data-id="element-277" />
                  <div data-id="element-278">
                    <h3 className="font-semibold text-lg" data-id="element-279">Address</h3>
                    <p className="text-rose-100 mt-1" data-id="element-280">
                      18 Cambridge Rd, Ilford IG3 8LU
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-281">
                  <Phone className="h-6 w-6 text-amber-400 mr-3 mt-0.5" data-id="element-282" />
                  <div data-id="element-283">
                    <h3 className="font-semibold text-lg" data-id="element-284">Phone</h3>
                    <p className="text-rose-100 mt-1" data-id="element-285">
                      <a href="tel:08000554969" className="hover:text-white" data-id="element-286">
                        0800 055 4969
                      </a>
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-287">
                  <Mail className="h-6 w-6 text-amber-400 mr-3 mt-0.5" data-id="element-288" />
                  <div data-id="element-289">
                    <h3 className="font-semibold text-lg" data-id="element-290">Email</h3>
                    <p className="text-rose-100 mt-1" data-id="element-291">
                      <a href="mailto:manishkisan879@gmail.com" className="hover:text-white" data-id="element-292">
                        manishkisan879@gmail.com
                      </a>
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-293">
                  <Clock className="h-6 w-6 text-amber-400 mr-3 mt-0.5" data-id="element-294" />
                  <div data-id="element-295">
                    <h3 className="font-semibold text-lg" data-id="element-296">Opening Hours</h3>
                    <div className="text-rose-100 mt-1 space-y-1" data-id="element-297">
                      <p data-id="element-298">Monday - Friday: 9:00am - 5:00pm</p>
                      <p data-id="element-299">Saturday - Sunday: Closed</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-10" data-id="element-300">
                <h3 className="font-semibold text-lg mb-4" data-id="element-301">Our Service Area</h3>
                <p className="text-rose-100 mb-4" data-id="element-302">
                  We provide appliance repair and maintenance services across
                  the UK. For specific coverage information or to check if we
                  service your area, please contact us directly.
                </p>
              </div>
              <div className="mt-10" data-id="element-303">
                <h3 className="font-semibold text-lg mb-4" data-id="element-304">Request a Repair</h3>
                <p className="text-rose-100 mb-4" data-id="element-305">
                  Need an appliance repaired? Contact us by phone or email to
                  schedule a service appointment. We'll typically arrange a
                  visit within 24-48 hours.
                </p>
                <a href="tel:08000554969" className="inline-flex justify-center items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-rose-900 bg-white hover:bg-rose-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-white" data-id="element-306">
                  Call Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};